import {Base} from "@/api/Base"

export class EmployeeEdit extends Base {
    path = "employee/edit"
}